import * as Actions from './state.actions';
import { IStates } from '../../logbooks/logbooks.model';
import { Action } from '@ngrx/store';

export interface FilterStateState {
  isLoading: boolean;
  isLoaded: boolean;
  data: IStates[];
}

export const initialFilterStateState: FilterStateState = {
  isLoaded: false,
  isLoading: false,
  data: [],
};

export function filterStateReducer(state = initialFilterStateState, baseAction: Action): FilterStateState {
  const action = baseAction as Actions.FilterStateActions;

  switch (action.type) {
    case Actions.START_LOAD_FILTER_STATES:
      return { ...state, isLoading: true };

    case Actions.FILTER_STATES_LOADED:
      return { ...state, data: action.data, isLoaded: true, isLoading: false };

    case Actions.RESET_STATE_STORE:
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        data: [],
      };
    default:
      return state;
  }
}
